import client from "../api/client";

export const getMembership = () => {
  return client('/api/membership').then(({ data }) => data.data);
};

export const getDocuments = () => {
  return client('/api/membership/documents').then(({ data }) => data.data);
};

export function useMembershipService () {
  return {
    getMembership,
    getDocuments,
  };
}
